module.exports = __webpack_public_path__ + "img/1487245652.2fc0bfce.jpg";